<template lang="pug">
.message-temp-file
  .file(:id="id" :style="{ minWidth: itemWidth, width: itemWidth, maxWidth: itemWidth }")
    .d-flex.align-items-center
      a.file-name(@click="download") {{ _fileName }}
  b-popover(ref="popovers" :target="id" placement="lefttop" triggers="hover") {{ _fileName }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { FileUrl } from "@/commons/services/OtherOfficeMessages";

/**
 * ### メッセージの添付ファイルコンポーネント
 */
@Component({})
export default class MessageTempFile extends Vue {
  /** ファイル */
  @Prop()
  value!: FileUrl;
  /** popover用のid属性 */
  @Prop()
  id!: string;
  /** 横幅 */
  @Prop({ type: String })
  itemWidth!: string;

  get _fileName(): string {
    return this.value.name;
  }

  public download(): void {
    this.$emit("download", this.value);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.message-temp-file {
  height: 42px;

  .file {
    display: inline-block;
    padding: 8px;
    border-radius: 3px;
    border: 1px solid $form-border-color;

    &:hover {
      background-color: $btn-draggable-hover !important;
      transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
    }

    .file-name {
      cursor: pointer;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
